import DOMPurify from 'dompurify';
import { AppList } from 'components/atoms';
import { parseStringIntoFormattedStringDate } from 'utils/parsers/dateTime/parseStringIntoFormattedStringDate';
import { DailyScheduleEntryDTO } from 'types/schedule/dailySchedule';

type DailyScheduleEntryItemProps = {
    entry: DailyScheduleEntryDTO;
};

export const DailyScheduleEntryItem = ({ entry }: DailyScheduleEntryItemProps) => {
    const entryDescription = entry.description ? DOMPurify.sanitize(entry.description) : '';
    const dateFrom = entry.dateFrom ? parseStringIntoFormattedStringDate(entry.dateFrom) : '';
    const dateTo = entry.dateTo ? parseStringIntoFormattedStringDate(entry.dateTo) : '';
    const dateRange = dateFrom && dateTo ? `${dateFrom} - ${dateTo}` : dateFrom || dateTo;

    return (
        <AppList.Item key={`${entry.dateFrom}-${entry.dateTo}`}>
            <div>
                {dateRange && <div style={{ marginBottom: 8, fontWeight: 500 }}>{dateRange}</div>}
                {entryDescription && (
                    <div
                        style={{ fontSize: '14px' }}
                        // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
                        dangerouslySetInnerHTML={{ __html: entryDescription }}
                    />
                )}
            </div>
        </AppList.Item>
    );
};
